export const PAYMENT_STATUSES = {
	CREATOR_FULFILLED: 1,
	PAID_NOT_FULFILLED: 2,
	REFUNDED: 3,
}

export const PRICE_OPTION_NAMES = {
	DEFAULT: 'DEFAULT',
	ANNUAL_SUBSCRIPTION: 'ANNUAL_SUBSCRIPTION',
}